var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('p',[_vm._v("抱歉，您无权访问")]),_c('p',[_c('span',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"el-icon-back"}),_vm._v("返回上一页")])]),_c('img',{attrs:{"src":require("@/assets/404.svg"),"alt":"404页面","width":"40%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }